module.exports = __webpack_public_path__ + "static/media/back.b46b57be.gif";